import { render, staticRenderFns } from "./CardQuotes.vue?vue&type=template&id=4a45ccfa&"
import script from "./CardQuotes.vue?vue&type=script&lang=js&"
export * from "./CardQuotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports